<template>
  <CustomFormBuilder :template-id="null" />
</template>

<script setup lang="ts">
import CustomFormBuilder from "./CustomFormBuilder.vue";
</script>
